//课程直播列表功能
import request from './request'

//课程创建
export function _courseAdd(data = {}) {
    const config = Object.assign(data, {
      method: 'post',
      url: '/admin/course/add',
    })
    return request(config)
  }

//课程修改
export function _courseEdit(data = {}) {
    const config = Object.assign(data, {
      method: 'post',
      url: '/admin/course/edit',
    })
    return request(config)
}

//课程上架
export function _courseOnline(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/online',
  })
  return request(config)
}

// 获取专题下的课程列表
export function _courseSingTopic(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/getinfo',
  })
  return request(config)
}

//课程下架
export function _courseOffline(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/offline',
  })
  return request(config)
}

//课程删除
export function _courseDel(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/del',
  })
  return request(config)
}


//课程直播列表
export function _getCourseList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/live',
  })
  return request(config)
}

//获取等待关联专题的课程（所有的）
// export function _courseWait(data = {}) {
//   const config = Object.assign(data, {
//     method: 'get',
//     url: '/admin/course/wait',
//   })
//   return request(config)
// }

//全部课程列表（直播，音频）
export function _getAllCourseList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/index',
  })
  return request(config)
}

//分享课程二维码
export function _couseShare(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/xcx/course',
  })
  return request(config)
}

//课程直播的去直播
export function _goLive(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/guestlink',
  })
  return request(config)
}

//删除专题的课程关联
export function  _delSpeContact(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/topic/remove-course',
  })
  return request(config)
}
